export enum ElementalType {
    NONE = -1,
    FIRE = 0,
    WATER = 1,
    LIGHT = 2,
    DARK = 3,
}

export enum ElementalTypeString {
    NONE = 'NONE',
    FIRE = 'FIRE',
    WATER = 'WATER',
    LIGHT = 'LIGHT',
    DARK = 'DARK',
}
